import { fg } from '@confluence/feature-gating';

export const initializeAggRegionSteeringHint = (fromValue?: string | null) => {
	if (!fg('cc-agg-migration_client-region-steering')) {
		window['GLOBAL_AGG_REGION_STEERING_HINT'] = null;
	} else if (fromValue && window['GLOBAL_AGG_REGION_STEERING_HINT'] === undefined) {
		window['GLOBAL_AGG_REGION_STEERING_HINT'] = fromValue;
	}
	return window['GLOBAL_AGG_REGION_STEERING_HINT'];
};
